"use client";
import { jsxs as l, jsx as n } from "react/jsx-runtime";
import { useLocaleText as h, Image as p, Overlay as b, Group as _, Heading as v, Button as y } from "@ingeniorforeningen/figurine-core";
import { forwardRef as C, useState as S, useEffect as s } from "react";
import '../../../../assets/CardSelectable.css';const N = "_root_18xbn_2", k = "_content_18xbn_21", j = "_overlay_18xbn_27", o = {
  root: N,
  content: k,
  overlay: j
}, i = C((d, f) => {
  const { header: m, image: x, onSelectChange: a, name: u, value: t, ...g } = d, r = h(), [e, c] = S(t || !1);
  return s(() => {
    t !== void 0 && c(t);
  }, [t]), s(() => {
    a && a(u, e);
  }, [e]), /* @__PURE__ */ l(
    p,
    {
      ...g,
      ...x,
      className: o.root,
      fit: "cover",
      ref: f,
      sizes: "300px",
      children: [
        /* @__PURE__ */ n(
          b,
          {
            gradient: "linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.3) 100%)",
            className: o.overlay
          }
        ),
        /* @__PURE__ */ l(
          _,
          {
            pt: "xl",
            direction: "column",
            p: "xl",
            pb: "xl",
            className: o.content,
            align: "center",
            children: [
              /* @__PURE__ */ n(v, { type: "h2", text: m, variant: "light", align: "center" }),
              /* @__PURE__ */ n(
                y,
                {
                  text: e ? r.chosen : r.choose,
                  onClick: () => c(!e),
                  icon: e ? "Check" : void 0,
                  variant: e ? "cta" : "outline",
                  contrast: "dark"
                }
              )
            ]
          }
        )
      ]
    }
  );
});
i.displayName = "CardSelectable";
const E = i;
export {
  i as _CardSelectable,
  E as default
};
